import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UnitOfMeasure } from '../../../models/unitofmeasure/unitofmeasure.model';
import { UnitOfMeasureService } from '../../../services/unit-of-measure.service';
import { CommonService } from 'src/app/core/services/common.service';
import { RoleConstant } from 'src/app/core/constants/role.constants';

@Component({
    selector: 'app-manage-unit-of-measure',
    templateUrl: './manage-unit-of-measure.component.html',
    styleUrls: ['./manage-unit-of-measure.component.css'],
    standalone: false
})
export class ManageUnitOfMeasureComponent implements OnInit {

  public id: number = 0;
  public isCreate: boolean = false;
  public name: string = '';
  public isActive: boolean = false;
  public headerText: string = "Create New Unit Of Measure"
  public code: string = ''

  constructor(public router: Router,
    private route: ActivatedRoute,
    private unitOfMeasureService: UnitOfMeasureService,
    public commonService: CommonService
  ) {
    let stateData: any = this.router.currentNavigation()?.extras.state;
    if (this.commonService.isNullOrEmptyOrUndefined(stateData)) {
      this.cancel();
    }
    this.id = stateData['id'];
    this.isCreate = stateData['isCreate']
    this.name = stateData['name'];
    this.isActive = stateData['isActive']
    this.code = stateData['code']
  }

  ngOnInit() {
    if (this.commonService.getUserRoleName() !== RoleConstant.ESAR_Admin) {
      this.router.navigate(['../../sar'], { relativeTo: this.route });
      return false;
    }
    if (!this.isCreate) {
      this.headerText = this.name;
    }
  }

  activeChanged(value: boolean) {
    this.isActive = value;
  }

  save() {
    const uom = new UnitOfMeasure();
    uom.id = this.id;
    uom.name = this.name;
    uom.isActive = this.isActive;
    uom.code = this.code;
    uom.createdBy = this.commonService.getUserEmailId();
    uom.modifiedBy = this.commonService.getUserEmailId();
    if (!this.isCreate) {
      this.unitOfMeasureService.updateUnitOfMeasure(uom).subscribe((response: UnitOfMeasure) => {
        this.router.navigate(["UOM"], { relativeTo: this.route.parent });
      });
    }
    else {
      this.unitOfMeasureService.saveUnitOfMeasure(uom).subscribe((response: UnitOfMeasure) => {
        this.router.navigate(["UOM"], { relativeTo: this.route.parent });
      });
    }
  }

  cancel() {
    this.router.navigate(["UOM"], { relativeTo: this.route.parent });
  }


}
